import { mainPalette } from '../palettes';
import typography from '../typography';

export default {
  root: {
    ...typography.body1,
    borderBottom: `1px solid ${mainPalette.divider}`
  }
};
